import { render, staticRenderFns } from "./RotationManage.vue?vue&type=template&id=7b2b0a42&scoped=true&"
import script from "./RotationManage.vue?vue&type=script&lang=js&"
export * from "./RotationManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2b0a42",
  null
  
)

export default component.exports